import { create } from "zustand"

// Domo Cero — store del panel de inspección 2D.
//
// Cuando un Tripulante toca rápido a otro avatar (o al suyo) abrimos
// un panel HTML overlay que muestra el Índice de Silicio + los 6
// pilares del Avatar inspeccionado. Vive aparte del LinkStore porque
// no es parte del ritual de enlace — es solo lectura.
//
// `inspectId` puede ser:
//   - "self"  → panel del Tripulante local
//   - peer.id → panel de un peer remoto
//   - null    → panel cerrado
//
// 2026-05-05 — Sustituye al TelemetryHologram 3D (drei <Html>
// transformado dentro del Canvas) que en escritorio se veía pesado y
// se cortaba con el reflector del piso. El panel 2D es legible desde
// cualquier ángulo, cabe en el viewport del iPhone sin desbordar y
// permite leer datos antes de pedir un enlace (no solo después).

interface InspectState {
    inspectId: string | "self" | null
    open: (id: string | "self") => void
    close: () => void
}

export const useInspectStore = create<InspectState>((set) => ({
    inspectId: null,
    open: (id) => set({ inspectId: id }),
    close: () => set({ inspectId: null }),
}))
